var render = function render(){var _vm=this,_c=_vm._self._c;return _c('SAISelect',_vm._g(_vm._b({attrs:{"value":_vm.computedValue,"emit-value":"","options":_vm.filteredOptions,"placeholder":"Select Reason"},on:{"filter":_vm.filterFn}},'SAISelect',_vm.$attrs,false),_vm.$listeners))
}
var staticRenderFns = []

export { render, staticRenderFns }